/**
 * Randomizes product grid item order on club collection pages.
 */
(function () {
  /**
   * @param {HTMLElement} list
   */
  function shuffleList(list) {
    const items = Array.from(list.children).filter((child) => child.tagName === 'LI');
    if (items.length < 2) return;

    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.forEach((item) => list.appendChild(item));
  }

  function init() {
    document.querySelectorAll('[data-shuffle-products]').forEach(shuffleList);
  }

  document.addEventListener('brentbear:shuffle-products', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
